/* Private Wondernara lab: opt-in, same-cart application re-use.
   Never copies organizer/platform IDs, event agreements, choices or documents.
   Never stores applicant data in localStorage, cookies, sessionStorage, URLs or logs. */
(() => {
  'use strict';
  const ROOT_ID = 'wn-quick-apply';
  const CART_PATH = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'cart.js';
  const allowed = new Set(['legalName','dateOfBirth','nationality','mobile','instagram']);
  function fieldType(text) {
    const x = String(text || '').toLowerCase().replace(/[\W_]+/g,' ').trim();
    if (!x || /agree|consent|policy|passport number|id number|photo id|document|video call member|raffle member|channel id|talk id|line id|linku|faceey|kakao|telegram|wechat|organizer|starmaker/.test(x)) return null;
    if (/(full name|legal name|name in english|name english|applicant name)/.test(x)) return 'legalName';
    if (/(date of birth|birth date|birthdate|birthday|\bdob\b)/.test(x)) return 'dateOfBirth';
    if (/nationality|country of citizenship|citizenship/.test(x)) return 'nationality';
    if (/(mobile number|mobile phone|phone number|contact number|cellphone|cell phone)/.test(x)) return 'mobile';
    if (/^ig$|\binstagram\b|\big username\b|\big handle\b/.test(x)) return 'instagram';
    return null;
  }
  function normalizeValue(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return '';
    const v = String(value).trim();
    if (!v || v.length>180 || /^(null|undefined|n\/a|none)$/i.test(v)) return '';
    return v;
  }
  function readFields(properties) {
    const values = {};
    Object.entries(properties || {}).forEach(([key,value]) => {
      const type=fieldType(key), v=normalizeValue(value);
      if (type && allowed.has(type) && v && !values[type]) values[type] = v;
    });
    return values;
  }
  function inputLabels(input) {
    const a=[input.name||'',input.id||'',input.placeholder||'',input.getAttribute('aria-label')||''];
    if (input.labels) Array.from(input.labels).forEach(l=>a.push(l.textContent||''));
    const labelledBy = input.getAttribute('aria-labelledby');
    if (labelledBy) labelledBy.split(/\s+/).forEach(id => {
      const label=document.getElementById(id);
      if (label) a.push(label.textContent||'');
    });
    const parent=input.closest('.form__field,.form-field,.form-group,.field,.mini-field,.mini-custom-field,.input-wrapper,.input-field,.custom-field');
    if (parent) {
      const labels=parent.querySelectorAll('label');
      if (labels.length===1) a.push(labels[0].textContent||'');
    }
    return a.join(' ');
  }
  function isoDate(raw) {
    const v=String(raw||'').trim();
    let y,m,d;
    let a=v.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:$|T)/);
    if (a) {y=+a[1];m=+a[2];d=+a[3];}
    else if ((a=v.match(/^(\d{1,2})([-/.])(\d{1,2})\2(\d{4})$/))) {
      d=+a[1];m=+a[3];y=+a[4]; // Cart application dates use day-month-year.
    }
    else {
      a=v.match(/^(\d{1,2})[\s-]+([a-zA-Z]{3,9})[\s,-]+(\d{4})$/);
      if (a) {
        const names=['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
        m=names.indexOf(a[2].toLowerCase().slice(0,3))+1;d=+a[1];y=+a[3];
      } else {
        a=v.match(/^([a-zA-Z]{3,9})[\s-]+(\d{1,2}),?[\s-]+(\d{4})$/);
        if (a) {
          const names=['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'];
          m=names.indexOf(a[1].toLowerCase().slice(0,3))+1;d=+a[2];y=+a[3];
        } else return '';
      }
    }
    if (!y || !m || !d || y < 1900 || y > new Date().getFullYear()) return '';
    const date=new Date(Date.UTC(y,m-1,d));
    if (date.getUTCFullYear()!==y || date.getUTCMonth()!==m-1 || date.getUTCDate()!==d) return '';
    return [y,String(m).padStart(2,'0'),String(d).padStart(2,'0')].join('-');
  }
  function setControl(field, value, kind) {
    if (field.disabled || field.readOnly) return false;
    let v=value;
    if (field.type==='date') {v=isoDate(value);if (!v) return false;}
    if (field.tagName==='SELECT') {
      const option=Array.from(field.options).find(o => o.value.toLowerCase()===String(v).toLowerCase()||o.textContent.trim().toLowerCase()===String(v).toLowerCase());
      if (!option) return false;
      v=option.value;
    }
    const old=String(field.value||'').trim();
    if (old) return false; // never replace information the customer already entered
    const proto=field.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:field.tagName==='SELECT'?HTMLSelectElement.prototype:HTMLInputElement.prototype;
    const setter=Object.getOwnPropertyDescriptor(proto,'value');
    if (setter && setter.set) setter.set.call(field,v); else field.value=v;
    field.dispatchEvent(new Event('input',{bubbles:true}));
    field.dispatchEvent(new Event('change',{bubbles:true}));
    return true;
  }
  function fill(profile, root, message) {
    const scope=root.closest('.main-product')||document.querySelector('.main-product');
    if (!scope) {message.textContent='Application form not found.';message.dataset.status='error';return;}
    const inputs=Array.from(scope.querySelectorAll('input,textarea,select')).filter(el => {
      const tp=(el.type||'').toLowerCase();
      return !el.disabled && !el.readOnly && (el.tagName==='TEXTAREA'||el.tagName==='SELECT'||['text','email','tel','date','search'].includes(tp));
    });
    const matches=new Map();
    inputs.forEach(input=>{
      const type=fieldType(inputLabels(input));
      if (type && allowed.has(type) && !matches.has(type)) matches.set(type,input);
    });
    // Mini:Custom Fields may render its date input without an associated label.
    // Use the lab's existing DOB marker, or the only native date field when a
    // distinct DOB label is present. Never guess between multiple date fields.
    if (!matches.has('dateOfBirth') && profile.values.dateOfBirth) {
      const dates = inputs.filter(input => input.tagName === 'INPUT' && input.type === 'date');
      const marked = dates.filter(input => input.classList.contains('wn-vc-lab-dob-input'));
      const dobLabelPresent = Array.from(scope.querySelectorAll('label')).some(label =>
        fieldType(label.textContent || '') === 'dateOfBirth'
      );
      if (marked.length === 1) matches.set('dateOfBirth', marked[0]);
      else if (dates.length === 1 && dobLabelPresent) matches.set('dateOfBirth', dates[0]);
    }
    let copied=0;
    const oldName=matches.get('legalName');
    if (oldName && oldName.value && profile.values.legalName && oldName.value.trim().toLowerCase() !== profile.values.legalName.trim().toLowerCase()) {
      message.dataset.status='error';
      message.textContent='This form already has a different applicant name. Please clear it before choosing another profile.';
      return;
    }
    allowed.forEach(key=>{
      const control=matches.get(key),v=profile.values[key];
      if (control && v && setControl(control,v,key)) copied+=1;
    });
    message.dataset.status=copied?'success':'error';
    message.textContent=copied
      ? '✓ Filled '+copied+' shared '+(copied===1?'detail':'details')+'. Review your details, then complete this event’s contact ID and agreement.'
      : 'No compatible empty fields were found. Please complete this event’s application normally.';
  }
  async function init() {
    const root=document.getElementById(ROOT_ID);
    if (!root||root.dataset.ready) return;
    root.dataset.ready='1';
    const profileWrap=root.querySelector('[data-quick-profiles]');
    const message=root.querySelector('[data-quick-message]');
    const info=root.querySelector('[data-quick-info]');
    try {
      const res=await fetch(CART_PATH,{credentials:'same-origin',headers:{'Accept':'application/json'},cache:'no-store'});
      if (!res.ok) throw Error('cart unavailable');
      const cart=await res.json();
      const cartItems=cart.items||[];
      const targetHandle=root.getAttribute('data-wn-vc-product')||'';
      const isAteezPart6=root.getAttribute('data-wn-vc-ateez-part6')==='true';
      // Make Quick Apply available across all seven ATEEZ Part.6 events.
      // All organizer IDs, member choices and agreements remain manual.
      if(!isAteezPart6 &&
         targetHandle!=='test-only-not-for-sale-wondernara-video-call-product-design-lab-ateez-kpopstore') {
        root.hidden=true;
        return;
      }
      const profiles=cartItems.filter(item=>{
        const title=(item.product_title||item.title||'').toLowerCase();
        return /video call|video fansign/.test(title)&&!title.includes('test only')&&!title.includes('not for sale')&&item.properties&&typeof item.properties==='object';
      }).map(item=>({title:item.product_title||'Video Call',values:readFields(item.properties)}))
        .filter(p=>p.values.legalName && Object.keys(p.values).length>=2);
      const unique=[];
      const seen=new Set();
      profiles.forEach(p=>{
        const key=(p.values.legalName||'').toLowerCase()+'|'+(p.values.dateOfBirth||'').toLowerCase();
        if (!seen.has(key)){seen.add(key);unique.push(p);}
      });
      if (!unique.length) {
        // First application: do not occupy space or show an irrelevant action.
        root.hidden=true;
        return;
      }
      root.hidden=false;
      info.textContent='Reuse your basic details from another application in your cart. Check the contact ID, member and agreement for this event.';
      unique.slice(0,5).forEach(profile=>{
        const btn=document.createElement('button');
        btn.type='button';
        btn.className='wn-quick-apply__button';
        btn.textContent='✨ Use details for '+profile.values.legalName;
        btn.addEventListener('click',()=>fill(profile,root,message));
        profileWrap.append(btn);
      });
    } catch(error) {
      // Keep the regular application form usable, with no distracting empty banner.
      root.hidden=true;
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();